module.exports = __webpack_public_path__ + "img/patrulla_municipal_up_selected.23079cf0.svg";